const contentTypeDefaultImage = {
  articles: "https://dw1.s81c.com/developer-static-pages/default/en/default_images/article.jpg",
  tutorials: "https://dw1.s81c.com/developer-static-pages/default/en/default_images/tutorial.jpg",
  videos: "https://dw1.s81c.com/developer-static-pages/default/en/default_images/video.jpg",
  patterns: "https://dw1.s81c.com/developer-static-pages/default/en/default_images/pattern.jpg",
  openprojects: "https://dw1.s81c.com/developer-static-pages/default/en/default_images/openproject.jpg",
  learningpaths: "https://dw1.s81c.com/developer-static-pages/default/en/default_images/learningpath.jpg",
  events: "https://dw1.s81c.com/developer-static-pages/default/en/default_images/event.jpg",
  courses: "https://dw1.s81c.com/developer-static-pages/default/en/default_images/course.jpg",
  blogs: "https://dw1.s81c.com/developer-static-pages/default/en/default_images/blog.jpg",
  series: "https://dw1.s81c.com/developer-static-pages/default/en/default_images/blog.jpg"
};

export default contentTypeDefaultImage;